import { Outlet } from 'react-router-dom';
import DashboardLayout from "./Dashboard";

const DashboardRoutes = () => {

  return (
    <DashboardLayout>
      <Outlet /> 
    </DashboardLayout>
  );
};

export default DashboardRoutes;